import { render, staticRenderFns } from "./ImagesForm.vue?vue&type=template&id=328a1f07&scoped=true&"
import script from "./ImagesForm.vue?vue&type=script&lang=js&"
export * from "./ImagesForm.vue?vue&type=script&lang=js&"
import style0 from "./ImagesForm.vue?vue&type=style&index=0&id=328a1f07&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "328a1f07",
  null
  
)

export default component.exports